import { request } from '@/api';
import { api3 } from '@api/env';
export function getList(params) {
  return request({
    baseURL: api3,
    url: '/api/interfaces',
    method: 'get',
    getHeaders: true,
    params: params
  });
}
export function create(data) {
  return request({
    baseURL: api3,
    url: '/api/interfaces',
    method: 'post',
    data: data
  });
}
export function getDetail(id) {
  return request({
    baseURL: api3,
    url: "/api/interfaces/".concat(id),
    method: 'get'
  });
}
export function update(id, data) {
  return request({
    baseURL: api3,
    url: "/api/interfaces/".concat(id),
    method: 'put',
    data: data
  });
}
export function deleteItem(id) {
  return request({
    baseURL: api3,
    url: "/api/interfaces/".concat(id),
    method: 'delete'
  });
}